import { Box, Toggle } from '@palmetto/palmetto-components';
import { useCallback } from 'react';

import { ProgramType, ProgramTypeLabels } from 'types';

interface ProgramHoldMotionToggleProps {
  programType: ProgramType;
  enabled: boolean;
  isDisabled: boolean;
  onToggle: (programType: ProgramType, enabled: boolean) => void;
}

export const ProgramHoldMotionToggle = ({
  programType,
  enabled,
  isDisabled,
  onToggle,
}: ProgramHoldMotionToggleProps) => {
  const handleChange = useCallback(() => {
    onToggle(programType, !enabled);
  }, [onToggle, programType, enabled]);

  return (
    <Box direction="row" gap="sm" alignItems="center" justifyContent="flex-end">
      <Box color={enabled ? 'primary' : 'grey-500'} fontWeight="medium" fontSize="sm">
        {enabled ? 'ON' : 'OFF'}
      </Box>
      <Toggle
        id={`holdMotion-${programType}`}
        label={`Hold Motion for ${ProgramTypeLabels[programType]}`}
        hideLabel
        isChecked={enabled}
        isDisabled={isDisabled}
        onChange={handleChange}
      />
    </Box>
  );
};
